import axios from 'axios';
import authHeader from "@/service/AuthHeader";
import getEnvironment from "@/service/Environment";

const API_LOGGED_IN_URL = getEnvironment().API_LOGGED_IN_URL + 'admin';
const API_URL = getEnvironment().API_URL;

class AuthService {
    login(user) {
        return axios
            .post(API_URL + 'login', {
                email: user.email,
                password: user.password
            })
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem('user', JSON.stringify(response.data.token));
                    localStorage.setItem('expire', response.data.expire);

                    this.getData().then(
                        (data) => {
                            localStorage.setItem('userData', JSON.stringify(data.data));
                        }
                    )
                }

                return response.data.token;
            });
    }

    getData() {
        return axios.get(API_LOGGED_IN_URL + '/user-data', { headers: authHeader() });
    }

    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('expire');
        window.location.href = "/";
    }
}

export default new AuthService();
